if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener(
					"submit",
					this.onSubmitHandler.bind(this)
				);
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");
				this.templateSuffix = document
					.querySelector("[data-template-suffix]")
					.getAttribute("data-template-suffix");
  // get server side cart once, set order level output form value based on that
        this.getCurrentCart().then((response) => {
          var usbQuantity = this.setUSBQuantity(response);
          var enhancedContentQuantity = this.setEnhancedContentQuantity(response);
          this.setOutputSummary(usbQuantity, enhancedContentQuantity);
        });
      }

			/* Custom Code for capture products */

			getCurrentCart() {
				return fetch(`${routes.cart_url}.json`)
					.then((response) => response.json())
					.catch((err) => console.log(err));
			}

      setOutputSummary(usbQuantity, enhancedContentQuantity) {
        if ((usbQuantity == 0) && (enhancedContentQuantity == 0)) {
          return; // nothing to do here.
        }
        var summaryWrapper = document.querySelector(
          ".product-outputs .summary__title"
        );
        let msg = '<p class="mt-3 usb-added">You have';
        if ((enhancedContentQuantity > 0) && (usbQuantity > 0)) {
          msg += ` Enhanced Content and ${usbQuantity} USB`
        } else if (enhancedContentQuantity > 0) {
          msg += ` Enhanced Content`
        } else if (usbQuantity > 0) {
          msg += ` ${usbQuantity} USB`
        }
        msg += " in your cart. You can make changes in the cart.</p>"
        summaryWrapper.insertAdjacentHTML(
          "beforeend",
          msg
        );
      }


      // set enhanced content quantity based on server side response


      setEnhancedContentQuantity(response) {
        var items = response.items;
        var enhancedContentItem = this.getProductItem(items, "upsellEnhancedContentID");
        if (enhancedContentItem) {
          var enhancedContentInput = document.querySelector(
            "[name='enhanced-content-quantity']"
          );
          // hide input line
          $(".enhanced-content-output").attr('style','display:none !important');
          if (enhancedContentInput) {
            enhancedContentInput.value = enhancedContentItem.quantity;
            // already in cart need to edit ti save
            $(enhancedContentInput).attr('data-incart', "true");
          }
          return enhancedContentItem.quantity; // enhanced item already in cart
        }

        return 0; // no enhanced content item
      }

      // set usb quantity based on server side response
      setUSBQuantity(response) {
        var items = response.items;
        var usbItem = this.getProductItem(items, "upsellUSBID");
        if (usbItem) {
          var usbInput = document.querySelector(
            "[name='usb-quantity']"
          );
          // hide input line
          $(".usb-output").attr('style','display:none !important');
          if (usbInput) {
            usbInput.value = usbItem.quantity;
            // already in cart need to edit ti save
            $(usbInput).attr('data-incart', "true");
          }

          return usbItem.quantity; // already have usb item in cart
        }
        return 0 // no server side cart item
      }

			getFormData() {
				var formData = [];
				formData.push(this.form.querySelector("[name=id]"));
				var formInputNames = [
					"album-quantity",
					"video-quantity",
					"film-quantity",
					"digital-quantity",
					"photo-quantity",
					"extra",
					"extra-slide",
					"extra-negative",
					"upsellDVDID",
					"dvd-quantity",
					"upsellUSBID",
					"usb-quantity",
          "upsellEnhancedContentID",
          "enhanced-content-quantity",
					"theme-outputs",
					"music-outputs",
					"memories-title",
					"memories-date",
					"memories-rewind",
					"original-audio",
				];
				var estimatedTotal =
					Number(
						document
							.querySelector(".product-price")
							.getAttribute("data-total-compare-price")
					) +
					Number(
						document
							.querySelector(".product-price")
							.getAttribute("data-upsell-dvd-total-price")
					) +
					Number(
						document
							.querySelector(".product-price")
							.getAttribute("data-upsell-usb-total-price")
					);
				formData.push({
					name: "estimatedTotal",
					value: estimatedTotal,
				});
				formInputNames.forEach((inputName) =>
					formData.push(...document.getElementsByName(inputName))
				);
				return formData;
			}

			getProduct(product_id) {
				// Capture specific variables
				var formData = this.getFormData();
				var productType =
					CONSTANTS.TEMPLATE_PRODUCT_MAP[this.templateSuffix];

				return {
					items: getCartItems(productType, product_id, 0, formData),
					attributes: {
						auto_export: true, // add auto_export field
					},
				};
			}

      getProductItem(items, idName) {
        var formData = this.getFormData();
        // find hidden div with the variant id for this product
        var id =
          formData.find(function (item) {
            return item.name === idName;
          })?.value ?? 0;
        var targetItem = items.find((item) => item.id == id);
          // Get current cart json
        if (targetItem) {
          return targetItem;
        }
      }

			async onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true")
					return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(
					".loading-overlay__spinner"
				).classList.remove("hidden");

				const config = fetchConfig("json");

				const formData = new FormData(this.form);
				const product_id = Number(formData.get("id"));
				if (this.cart) {
					formData.append(
						"sections",
						this.cart
							.getSectionsToRender()
							.map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}

				var newCartItems = this.getProduct(product_id);

				config.body = JSON.stringify(newCartItems);
				this.addToCart(config);
			}

			changeCart(body) {
				return fetch(`${routes.cart_change_url}`, {
					...fetchConfig(),
					...{ body },
				}).then((response) => {
					return response.text();
				});
			}

			updateCart(body) {
				return fetch(`${routes.cart_update_url}`, {
					...fetchConfig(),
					...{ body },
				}).then((response) => {
					return response.json();
				}).catch((error) => {
          console.error('Error:', error);
        });
			}

			addToCart(config) {
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(
									".sold-out-message"
								);
							if (!soldOutMessage) return;
							this.submitButton.setAttribute(
								"aria-disabled",
								true
							);
							this.submitButton
								.querySelector("span")
								.classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (
							this.cart &&
							this.cart.classList.contains("is-empty")
						)
							this.cart.classList.remove("is-empty");
						if (!this.error)
							this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(
							".loading-overlay__spinner"
						).classList.add("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute(
					"hidden",
					!errorMessage
				);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
